import * as React from 'react';
import { SVGProps } from 'react';

const FileIconGifSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      d="M13 3V2h-1v1h1ZM11 4v1h1v3h-1v1h3V8h-1V4h-2ZM17.35 3a.374.374 0 0 0-.26.09.268.268 0 0 0-.09.21V4h1v1h-1v3h1v1h-3V8h1V5h-1V4h1v-.9c0-.34.097-.607.29-.8.193-.2.443-.3.75-.3h1.46v1h-1.15Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 8.8c-.207.133-.457.2-.75.2H7.7c-.587 0-1.017-.123-1.29-.37C6.137 8.377 6 7.967 6 7.4V5.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38H10v6a1 1 0 0 1-1 1H6.5v-1H8c.84 0 1 0 1-1v-.2ZM8.35 8c.22 0 .383-.057.49-.17A.566.566 0 0 0 9 7.45V5H7.75c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.6Z"
      fill="#fff"
    />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 14H6v6.667L9 18l6.5 6H18V14H6.5ZM6 23.5v-1.167l3-2.81L14 24H6v-.5Zm-1-9V25h14V13H5v1.5Zm8 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconGifSizeS;
